import {
  CanActivateChildFn,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';
import { DashboardGlobalConfigType, ToastService } from '@ckmk/angular';
import { PostService } from '@app/src/app/modules/post/service/post.service';
import { inject } from '@angular/core';

export const PostGuard =
  (config?: DashboardGlobalConfigType): CanActivateFn | CanActivateChildFn =>
  async (route, state) => {
    const service = inject(PostService);
    const toast = inject(ToastService);
    const router = inject(Router);
    const dashboardPath = config ? inject(config.tokens.pathBuilder) : null;

    return service
      .isExists(route, config)
      .then((value) => {
        if (!value) {
          const path = dashboardPath ? dashboardPath('/posts/list') : '/blog';

          if (config) {
            toast.warning({
              text: 'Post not found',
              domain: 'warnings',
            });
          }

          return new RedirectCommand(router.createUrlTree([path]), {
            replaceUrl: true,
          });
        }

        return true;
      })
      .catch(() => {
        const path = dashboardPath ? dashboardPath('/posts/list') : '/blog';

        if (config) {
          toast.warning({
            text: 'Post not found',
            domain: 'warnings',
          });
        }

        return new RedirectCommand(router.createUrlTree([path]), {
          replaceUrl: true,
        });
      });
  };
